module.exports = __webpack_public_path__ + "static/img/banner.978eeada.png";